export enum HOMETOWNS_DETAIL_TAB {
  GIFTS = 'gifts',
  PROJECTS = 'projects',
  POLICY = 'policy',
  CONTENTS = 'contents',
  REVIEWS = 'reviews',
  BENEFITS = 'benefits',
}

export const DEFAULT_GIFT_PRODUCT_SORT = 'POPULAR';
